import useTranslation from 'next-translate/useTranslation';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import styled from 'styled-components';

import CloseButton from '@/components/CloseButton';

const ProgressBox = styled(Flex)`
  width: 100%;

  progress[value] {
    appearance: none;
    height: 5px;

    ::-webkit-progress-bar {
      max-width: 100%;
      width: 100%;
      border-radius: 15%;
      height: 5px;
      background-color: #f7f7f7;
    }

    ::-webkit-progress-value {
      transition: all 200ms ease;
      max-width: 100%;
      width: 100%;
      border-radius: 15%;
      height: 5px;
      background-color: #e2001a;
    }
  }
`;

const ProgressBar = ({ value, onCancel, isWidget, ...props }) => {
  const { t } = useTranslation('page-dashboard');
  const uploading = t('DocumentTile.Dropzone.actionStates.uploading.text', {}, { returnObjects: true });

  return (
    <ProgressBox flexDirection="column" {...props}>
      <Flex justifyContent="space-between" alignItems="center" mb={isWidget ? '5px' : ['5px', '10px']}>
        <Box>
          <Text color="darkGrey" fontSize="12px" mr="1">
            {uploading ?? 'Ihr Dokument wird hochgeladen..'}
          </Text>
        </Box>
        <CloseButton onClick={onCancel} />
      </Flex>

      <progress style={{ width: '100%' }} value={value} max={100} />
    </ProgressBox>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  isWidget: PropTypes.bool.isRequired,
};
export default ProgressBar;
